import icon from '@/assets/image/loading.gif'

let instance = null;

class Loading {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    static show(el = '#app') {
        if (!instance) {
            instance = new Loading();
        }

        if (instance.isLoadingShown) {
            return;
        }

        instance.isLoadingShown = true;

        const app = document.querySelector(el);
        if (!app) return;

        instance.loadingElement = document.createElement('div');
        instance.loadingElement.id = 'loading';
        instance.loadingElement.innerHTML = `<img src="${icon}">`;
        app.appendChild(instance.loadingElement);
    }

    static hide() {
        if (!instance || !instance.isLoadingShown) {
            return;
        }

        instance.isLoadingShown = false;

        const loadingElement = instance.loadingElement;
        if (!loadingElement) return;

        loadingElement.style.opacity = 0;
        setTimeout(() => {
            loadingElement.style.display = 'none';
            loadingElement.remove();
        }, 200);
    }
}

export default Loading;
